const ListTypeEnum = {
  APP: 1,
  DEVELOPER: 2,

  cases() {
    return {
      [this.APP]: 'APP',
      [this.DEVELOPER]: 'DEVELOPER',
    };
  },

  ids() {
    return Object.keys(this.cases()).map(Number);
  },

  names() {
    return Object.values(this.cases());
  },

  fromId(id) {
    return this.cases()[id] || null;
  },

  toId(name) {
    const cases = this.cases();
    return Object.keys(cases).find((key) => cases[key] === name) || null;
  },

  isValidId(id) {
    return this.ids().includes(id);
  },

  allOptions(includeAllOption = false) {
    const options = Object.entries(this.cases()).map(([id, name]) => ({
      id: Number(id),
      name,
    }));
    return options;
  },
};

export default ListTypeEnum;
